// Rótulos normativos da ficha `inspection-v1` (form §7.3).
// Namespace `inspection.catalog.v1.*` — cada versão tem o próprio subtree.

export const inspectionCatalogV1PtBR = {
  common: {
    yes: "Sim",
    no: "Não",
    na: "N/A",
    notApplicable: "Não se aplica",
    good: "Bom",
    regular: "Regular",
    deficient: "Deficiente",
    observations: "Observações",
    photos: "Fotos",
    others: "Outros (identificar)",
    describe: "Descrever",
    local: "Local",
    note: "Nota",
    type: "Tipo",
    value: "Valor",
    flowRate: "Vazão",
    elevationM: "Elev. (m)",
    lengthM: "Comprimento (m)",
    openingMm: "Abertura (mm)",
    orientation: "Orientação",
    manifestation: "Manifestação",
    solidCarryover: "Carreamento visível de sólidos",
    cleaningState: "Estado de limpeza",
    structuralCondition: "Condição estrutural",
    structuralConditions: "Condições estruturais",
    addCrack: "Adicionar trinca",
    addSettlement: "Adicionar recalque",
    addSeepage: "Adicionar surgência",
    addErosion: "Adicionar erosão",
    addLine: "Adicionar linha",
    addOccurrence: "Adicionar ocorrência",
  },
  choices: {
    longitudinal: "Longitudinal",
    transversal: "Transversal",
    crest: "Crista",
    berms: "Bermas",
    slopes: "Taludes",
    depression: "Depressão / Abatimento",
    settlement: "Recalque",
    grassNeedsPruning: "Gramínea necessitando de poda",
    controlledOrAbsentDuringRaising: "Controlado / Ausente em alteamento",
    shrubOrTreeVegetation: "Arbustiva e/ou arbórea",
    absentWithoutRaising: "Ausente sem alteamento",
  },
  placeholders: {
    local: "trecho, coordenada, estaca…",
    othersDescribe: "Identifique o achado residual…",
    othersObservations: "Observações complementares…",
    lengthExample: "Ex.: 3,20",
    openingExample: "Ex.: 5",
    flowValue: "Valor e unidade (ex: 0,5 L/s)",
    elevation: "Elevação (m)…",
    beachLength: "Ex: 15,00 m…",
    flowRate: "Vazão:…",
  },
  steps: {
    generalData: "Dados gerais",
    accesses: "Situação dos Acessos",
    damBody: "Maciço da Barragem / Ombreiras",
    reservoir: "Reservatório",
    spillway: "Extravasor(es) / Vertedor(es)",
    instrumentation: "Instrumentação (integridade física, identificação, acesso)",
    beachCondition: "Condição de Praia",
    tailingsWaterIntake: "Adutoras de Rejeito / Captação de Água",
    conservationState: "Estado de conservação",
    generalComments: "Comentários gerais",
    signatures: "Assinaturas",
  },
  stepShort: {
    accesses: "Acessos",
    damBody: "Maciço",
    reservoir: "Reservatório",
    spillway: "Extravasor",
    instrumentation: "Instrumentação",
    beachCondition: "Condição de praia",
    tailingsWaterIntake: "Adutoras / Captação",
  },
  sections: {
    pests: "Presença de insetos / animais",
    internalDrainage: "Drenagem interna",
    geomembraneOccurrences: "Ocorrências de geomembrana",
  },
  occurrence: {
    crack: "Trinca",
    settlement: "Recalque",
    seepage: "Surgência",
    erosion: "Erosão",
    geomembrane: "Geomembrana",
  },
  items: {
    accesses: {
      generalConservation: "Conservação Geral",
      slopes: "Taludes",
      floorPavement: "Revestimento do Piso",
      drainageDevices: "Dispositivos de drenagem",
    },
    damBody: {
      cracksIdentified: "Trincas identificadas",
      settlementsIdentified: "Recalques identificados",
      seepagesIdentified: "Surgência(s) d'água identificada(s)",
      surfaceErosions: "Erosões superficiais",
      surfaceDrainage: "Drenagem superficial",
      drainageChannel: "Canal de drenagem",
      vegetalCover: "Revestimento vegetal",
      pests: {
        termitesRodents: "Formigueiros / Cupins / Roedores",
        animals: "Animais (verificar pegadas / fezes)",
        burrows: "Presença de tocas ou buracos",
      },
      internalDrainage: {
        outletSilting: "Assoreamento da saída do dreno/colóide",
        solidCarryover: "Carreamento visível de sólidos",
        flowChange: "Alteração significativa da vazão",
        drainSaturation: "Saturação ao redor do dreno",
        flowMeterOperational: "Medidor de vazão operante",
        flowMeasured: "Vazão da drenagem interna aferida na inspeção",
      },
      complementaryStructures: "Estruturas complementares",
      reinforcement: "Estrutura de Reforço (contrapilhamento, berma de equilíbrio, etc.)",
      saddleDike: "Dique de Sela",
      sump: "Sump atrelado à estrutura",
    },
    reservoir: {
      bankCondition: "Condição das margens (Erosões ou Processos de Instabilização)",
      impermeabilized: "Reservatório impermeabilizado",
      geomembraneConservation: "Estado de conservação da Geomembrana",
      operationalFreeboard: "Borda Livre Operacional",
    },
    spillway: {
      type: "Tipo de Extravasor / Vertedor",
      inletSectionCondition: "Condição da seção do emboque",
      outletSectionCondition: "Condição da seção do desemboque",
      stillingBasinCondition: "Condição da bacia de dissipação",
      structuralCondition: "Condição estrutural",
      hasEmergencySpillway: "Possui extravasor de emergência?",
    },
    instrumentation: {
      access: "Acesso aos Instrumentos",
      protection: "Proteção dos Instrumentos",
      conservationState: "Estado de Conservação",
      localGaugesCondition:
        "Condição dos Aferidores Locais (régua, graduação pluviométrica, baldes, trena com sensor sonoro)",
      identification: "Identificação dos Instrumentos",
    },
    beachCondition: {
      tailingsDisposal: "Disposição/manejo do rejeito no reservatório",
      safeWaterDistance: "Distância segura da lâmina d'água em relação a crista",
      physicalSignaling: "Condição operacional da sinalização física (tambores)",
      beachLengthVsCrest: "Comprimento da condição de praia em relação a crista (Se aplicável)",
    },
    tailingsWaterIntake: {
      tailingsInflow: "Está havendo aporte de rejeito no reservatório?",
      tailingsLineLeak: "A linha de rejeito apresenta sinais de vazamento?",
      waterPumpingActive:
        "Está havendo bombeamento de água do reservatório? Indicar se está ativo",
      waterPipeLeak: "A tubulação de água apresenta sinais de vazamento?",
      intakeOperating: "O sistema de captação está operando normalmente? Qual a vazão:",
      bargeAccessOperating: 'O acesso ao sistema de captação "balsa" está operando?',
    },
  },
} as const;
